import cn from 'clsx'

// Components
import { Link, useMaxWidth } from '@tracklib/kit'
import NavLinkDropdown from 'components/header/navlinkdropdown'

import styles from './navlink.css'

type LinkType = {
  text: string
  url: string
  matchUrls?: Array<string>
  onlyMobile?: boolean
  disabled_for?: number
  loggedin_required?: number
  open_in_new_tab?: boolean
  links?: Array<{
    url: string
    text: string
  }>
  onlyLinksMobile?: boolean
  linksDefaultOpenMobile?: boolean
}

type NavLinkProps = {
  link: LinkType
  isAuthenticated: boolean
  compressed: boolean
  activePath: string
  onLinkClick: () => void
}

const NavLink = ({ link, isAuthenticated, compressed, activePath, onLinkClick }: NavLinkProps): JSX.Element | null => {
  const {
    text,
    url,
    matchUrls,
    disabled_for,
    loggedin_required = 99,
    open_in_new_tab,
    links,
    onlyMobile,
    onlyLinksMobile,
    linksDefaultOpenMobile,
  } = link
  const isSmall = useMaxWidth()

  let disabled
  if (!disabled_for) {
    disabled = false
  } else if (+disabled_for === 0 || (isAuthenticated && +disabled_for === 1) || (!isAuthenticated && +disabled_for === 2)) {
    disabled = true
  } else {
    disabled = false
  }

  if (!isSmall && onlyMobile) {
    return null
  }

  if ((!isAuthenticated && loggedin_required && +loggedin_required === 1) || (isAuthenticated && +loggedin_required === 2)) {
    return null
  }

  let linkIsActive = false
  if (url === '/blog/' && activePath === '/blog/inspectahdeck/') {
    linkIsActive = false
  } else if (url === '/') {
    linkIsActive = activePath === url
  } else if (matchUrls) {
    linkIsActive = matchUrls.some(matchUrl => activePath.startsWith(matchUrl))
  } else {
    linkIsActive = activePath.startsWith(url)
  }

  return (
    <li className={cn(styles.link, compressed && styles.linkCompressed)}>
      {open_in_new_tab ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      ) : (
        <>
          {links?.length && !(!isSmall && onlyLinksMobile) ? (
            <NavLinkDropdown
              links={links}
              label={text}
              url={url}
              isActiveLink={linkIsActive}
              activePath={activePath}
              onLinkClick={onLinkClick}
              defaultOpen={linkIsActive || ((activePath === '/' || activePath === '/blog/') && linksDefaultOpenMobile)}
            />
          ) : (
            <Link to={url} disabled={disabled} className={cn(linkIsActive && styles.active)} onClick={onLinkClick}>
              {text}
            </Link>
          )}
        </>
      )}
    </li>
  )
}

export default NavLink
